import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';



import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';
/**
 * @version $Id: group.service.ts 81701 2018-03-08 23:46:04Z thiago.h.neri $
 */
@Injectable()
export class GroupService extends CommonService  {

  private localURL: string;
  private GROUP_MANAGER_PATH: string = '/datapackmanagergroup';

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.GROUP_MANAGER_PATH;
  }

  public save(data: string) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }

  public remove(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }
}


// WEBPACK FOOTER //
// ./src/app/services/group.service.ts